import React from 'react';
// import PageLink from '@/src/module/jhc-pageLink';

export default class SubmitSaved extends React.Component {
  constructor (props) {
    super(props);
  }

  handlerClick= (e)=> {
    this.props.offModal();
  }

  handlerLink= (e)=> {
    // e.stopPropagation();
    e.preventDefault();
  	this.props.IndexClass.routing.routing('/');
    this.props.offModal();
  }

  render () {
    return (
      <div className="pd-40 m-pd-0">
        <p className="">
          <i className="ft-mi ft1 ft-bi v-mid">check_circle_outline</i>
          <span className="ft3 m-ft3 ft-bi v-mid mg-l5 lh-12">
            {this.props.msg && this.props.msg}
            {this.props.msg === true && '신청이 접수되었습니다. 등록하신 이메일주소로 라이선스키를 발송해 드립니다. SDK는 다운로드(링크)에서 받으실 수 있습니다.'}
          </span>
        </p>
        
        <p className="mg-t20">
          <span
            onClick={this.handlerClick}
            className="iblock-box bg-clr-bk pd-s20 pd-h5 cursor-point ft-bi ft-wh"
          >
            닫기
          </span>
        </p>
      </div>
    )
  }
}